<template>
  <div class="pattern">
    <div class="navigationBar nav">
      <div style="display: flex; width: 80%; justify-content: space-between">
        <div
          v-for="(item, index) of menuList"
          :key="index"
          class="menu"
          :style="[{ color: patientia == item.path ? '#fff' : '' }]"
          @click="jump(item.path, item)"
        >
          <span class="typeface">{{ item.name }}</span>
        </div>
        <!-- <div
          id="celebrityMonitor"
          v-if="ruleId == 2 || ruleId == 3"
          class="menu secondary"
          style="width: 5rem"
          :style="[
            {
              color:
                patientia == '/darenMonitor' || patientia == '/earlyWarn'
                  ? '#fff'
                  : '',
            },
          ]"
          @click="showMenu"
        >
          <span style="display: inline-block; width: 2.5rem" class="typeface"
            >名人监测</span
          >
          <img
            style="display: inline-block; vertical-align: super"
            src="../assets/images/expert/bottom.png"
          />
          <ul id="element" style="bottom: -90px">
            <li
              :class="patientia == '/darenMonitor' ? 'active' : ''"
              @click="jump('/darenMonitor')"
            >
              名人监测
            </li>
            <li
              :class="patientia == '/earlyWarn' ? 'active' : ''"
              @click="jump('/earlyWarn')"
            >
              预警管理
            </li>
          </ul>
        </div> -->
      </div>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect videoRadio"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span>{{ name }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="personalData">
            <div>个人资料</div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="pointsDetails">
            <div>积分管理</div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <div>退出登录</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      name: "", //当前登录用户用户名
      patientia: "/",
      video: "0",
      ruleId: 0,
      menuList: [
        { name: "专项监测", path: "/mySubscription" },
        { name: "全网搜索", path: "/" },
        { name: "专项分析", path: "/brandPublicOpinion" },
        { name: "我的下载", path: "/myDownload" },
      ],
    };
  },
  mounted() {
    this.name = window.localStorage.getItem("username");
    this.patientia = this.$route.path;
    this.ruleId = window.localStorage.getItem("ruleId");
    // if (this.ruleId == 2 || this.ruleId == 3) {
    //   this.$nextTick(() => {
    //     let element = document.getElementById("celebrityMonitor");
    //     console.log(element);
    //     let menu = document.getElementById("element");
    //     document.addEventListener("click", function (event) {
    //       if (!element.contains(event.target)) {
    //         menu.style.display = "none";
    //       }
    //     });
    //   });
    // }
  },
  methods: {
    /**个人资料 */
    personalData() {
      this.$router.push("/personalData");
    },
    /**积分管理 */
    pointsDetails() {
      this.$router.push("/pointsDetails");
    },
    showMenu() {
      let element = document.getElementById("element");
      if (element.style.display === "block") {
        element.style.display = "none";
      } else {
        element.style.display = "block";
      }
    },
    /**退出登录 */
    logout() {
      this.$router.push("/login");
      localStorage.removeItem("token");
    },
    /**跳转 */
    jump(val) {
      let that = this;
      if (val == that.$route.path) {
      } else {
        // let { href } = this.$router.resolve({
        //   path: val,
        // });
        // window.open(href, "_self");
        this.$router.push(val);
      }
    },
  },
  watch: {
    "$route.path"(val, b) {
      console.log(val);
      this.patientia = val;
      if (val == "/mobile/publicOpinionSearch") {
        this.patientia = "/";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nav {
  /deep/ .avatar-wrapper {
    margin-top: 18px !important;
  }
}
.typeface {
  font-size: 18px;
  text-decoration: none;
}
/////////////////////////
.nav ul {
  position: absolute;
  left: 0;
  padding-top: 10px;
  background: #fff;
  width: 100%;
  display: none;
  z-index: 1700;
}
.nav > .appbar {
  height: 100%;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  padding: 0 20px;
  width: 90px;
}
// .nav > div:hover ul {
//   display: block;
// }
.nav ul li {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
}
/////////////////////////
// .menu:hover {
//   // background: #fff;
//   color: #fff;
// }
.menu {
  color: #97a5bd;
  border-bottom-color: transparent;
  background-color: #1d3561;
  // width: 8rem;
  width: 5.5rem;
  text-align: center;
  font-size: 14px;
  // padding: 0 20px;
  float: left;
  height: 59px;
  // line-height: 59px;
  margin: 0;
  border-bottom: 1px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigationBar {
  width: 100%;
  height: 60px;
  background-color: #1d3561;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: 0px 2px 10px 0px rgba(65, 65, 65, 0.15);
}
.avatar-container {
  // margin-right: 30px;

  .avatar-wrapper {
    margin-top: 20px;
    position: relative;

    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }

    .el-icon-caret-bottom {
      cursor: pointer;
      position: absolute;
      // right: -20px;
      top: 7px;
      font-size: 12px;
    }
  }
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  // height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;
  position: absolute;
  right: 2%;
  color: #fff;

  &.hover-effect {
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      // background: rgba(0, 0, 0, 0.025);
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.userStyle {
  position: absolute;
  left: 95%;
  color: #fff;
  line-height: 60px;
  cursor: pointer;
}
.fontSize {
  font-size: 17px;
}
/deep/ .el-radio {
  width: 122px;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
}
.secondary {
  position: relative;
  ul {
    position: absolute;
    left: 0;
    padding-top: 10px;
    background: #1d3561;
    width: 100%;
    display: none;
    color: #97a5bd;
    > li:hover {
      color: #fff;
    }
  }
}
.active {
  color: #fff;
}
</style>
